<div style="text-align:center;padding:5px;" *ngIf="mealService && mealService.length == 0" translate>
    No Meal Service data exists for student.
</div>
<div *ngIf="mealService && mealService.length > 0">
    <table mat-table #table [dataSource]="angularMatData" multiTemplateDataRows matSort matSortDisableClear
        matSortActive="Date" matSortDirection="desc" id="MSdataTable" style="width: 100%;"
        aria-label="Charges and Deposits Data Table" tabindex="0">
        <ng-container matColumnDef="More">
            <th mat-header-cell [ngStyle]="{'display': 'none'}" *matHeaderCellDef
                style="min-width:100px;max-width:100px;" class="print-ignore">
                <span translate>More</span>
            </th>
            <td mat-cell *matCellDef="let MS ;"
                style="min-width:100px;max-width:100px;cursor: pointer;font-weight: bold;font-size: 15px;"
                class="print-ignore">
                <span aria-label="Expand row for more details">
                    <i [ngClass]="checkExpanded(MS) ? 'detail-row-expanded-icon' : 'detail-row-collapsed-icon'"
                        class="material-icons" aria-hidden="true"></i>
                </span>
            </td>
        </ng-container>
        <ng-container matColumnDef="Date">
            <th mat-header-cell [ngStyle]="{'display': 'none'}" *matHeaderCellDef
                style="min-width:120px;max-width:120px;">
                <span translate>Date</span>
            </th>
            <td mat-cell *matCellDef="let MS" style="min-width:120px;max-width:120px;">
                <span style="width:33px;">{{MS.Date|date:'EEE'}}</span> {{MS.Date|date:'MM/dd/yy'}}
            </td>
        </ng-container>
        <ng-container matColumnDef="BreakFastMeal">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
                style="max-width: 100px;min-width: 100px;;text-align: right;padding-left: 10px;">
                <span translate>Meal</span>
                <filter class="mat-filter" [data]="angularMatData" columnName="BreakFastMeal" dataType="string">
                </filter>
            </th>
            <td mat-cell *matCellDef="let MS" [ngStyle]="{'color':MS.BreakFastMeal == 0 ? '#939393' : 'black'}"
                style="max-width: 100px;min-width: 100px;padding-left: 10px;text-align: right;padding-right: 55px;">
                <span>{{MS.BreakFastMeal}}</span>
            </td>
        </ng-container>
        <ng-container matColumnDef="BreakFastALaCarte">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
                style="max-width: 120px;min-width: 120px; border-right: thin solid lightgray;text-align: right;">
                <span>A La Carte</span>
                <filter class="mat-filter" [data]="angularMatData" columnName="BreakFastALaCarte" dataType="string">
                </filter>
            </th>
            <td mat-cell *matCellDef="let MS" [ngStyle]="{'color':MS.BreakFastALaCarte == 0 ? '#939393' : 'black'}"
                style="max-width: 120px;min-width: 120px;text-align: right;padding-right: 55px;">
                <span>{{MS.BreakFastALaCarte}}</span>
            </td>
        </ng-container>
        <ng-container matColumnDef="LunchMeal">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
                style="max-width: 100px;min-width: 100px;;text-align: right;padding-left: 10px;">
                <span translate>Meal</span>
                <filter class="mat-filter" [data]="angularMatData" columnName="LunchMeal" dataType="string"></filter>
            </th>
            <td mat-cell *matCellDef="let MS" [ngStyle]="{'color':MS.LunchMeal == 0 ? '#939393' : 'black'}"
                style="max-width: 100px;min-width: 100px;padding-left: 10px;text-align: right;padding-right: 55px;">
                <span>{{MS.LunchMeal}}</span>
            </td>
        </ng-container>
        <ng-container matColumnDef="LunchALaCarte">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
                style="max-width: 120px;min-width: 120px; border-right: thin solid lightgray;text-align: right;">
                <span>A La Carte</span>
                <filter class="mat-filter" [data]="angularMatData" columnName="LunchALaCarte" dataType="string">
                </filter>
            </th>
            <td mat-cell *matCellDef="let MS" [ngStyle]="{'color':MS.LunchALaCarte == 0 ? '#939393' : 'black'}"
                style="max-width: 120px;min-width: 120px;text-align: right;padding-right: 55px;">
                <span>{{MS.LunchALaCarte}}</span>
            </td>
        </ng-container>
        <ng-container matColumnDef="SnackMeal">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
                style="max-width: 100px;min-width: 100px;;text-align: right;padding-left: 10px;">
                <span translate>Meal</span>
                <filter class="mat-filter" [data]="angularMatData" columnName="SnackMeal" dataType="string"></filter>
            </th>
            <td mat-cell *matCellDef="let MS" [ngStyle]="{'color':MS.SnackMeal == 0 ? '#939393' : 'black'}"
                style="max-width: 100px;min-width: 100px;padding-left: 10px;text-align: right;padding-right: 55px;">
                <span>{{MS.SnackMeal}}</span>
            </td>
        </ng-container>
        <ng-container matColumnDef="SnackALaCarte">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
                style="max-width: 120px;min-width: 120px; border-right: thin solid lightgray;text-align: right;">
                <span>A La Carte</span>
                <filter class="mat-filter" [data]="angularMatData" columnName="SnackALaCarte" dataType="string">
                </filter>
            </th>
            <td mat-cell *matCellDef="let MS" [ngStyle]="{'color':MS.SnackALaCarte == 0 ? '#939393' : 'black'}"
                style="max-width: 120px;min-width: 120px;text-align: right;padding-right: 55px;">
                <span>{{MS.SnackALaCarte}}</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="OtherMeal">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
                style="max-width: 100px;min-width: 100px;;text-align: right;padding-left: 10px;">
                <span translate>Meal</span>
                <filter class="mat-filter" [data]="angularMatData" columnName="OtherMeal" dataType="string"></filter>
            </th>
            <td mat-cell *matCellDef="let MS" [ngStyle]="{'color':MS.OtherMeal == 0 ? '#939393' : 'black'}"
                style="max-width: 100px;min-width: 100px;padding-left: 10px;text-align: right;padding-right: 55px;">
                <span>{{MS.SnackMeal}}</span>
            </td>
        </ng-container>
        <ng-container matColumnDef="OtherALaCarte">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
                style="max-width: 120px;min-width: 120px; border-right: thin solid lightgray;text-align: right;">
                <span>A La Carte</span>
                <filter class="mat-filter" [data]="angularMatData" columnName="OtherALaCarte" dataType="string">
                </filter>
            </th>
            <td mat-cell *matCellDef="let MS" [ngStyle]="{'color':MS.OtherALaCarte == 0 ? '#939393' : 'black'}"
                style="max-width: 120px;min-width: 120px;text-align: right;padding-right: 55px;">
                <span>{{MS.SnackALaCarte}}</span>
            </td>
        </ng-container>
        <ng-container matColumnDef="TotalPurchases">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
                style="padding-left:10px;min-width:150px;max-width:150px;justify-content:flex-end;text-align: right;">
                <span translate>Total Charges</span>
                <filter class="mat-filter" [data]="angularMatData" columnName="TotalPurchases" dataType="string">
                </filter>
            </th>
            <td mat-cell *matCellDef="let MS"
                style="padding-left:10px;min-width:150px;max-width:150px;justify-content:flex-end;text-align: right;padding-right: 55px;"
                [ngStyle]="{'color':MS.TotalPurchases == 0 ? '#939393' : 'black'}">{{MS.TotalPurchases}}</td>
        </ng-container>
        <ng-container matColumnDef="Deposits">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
                style="padding-right:10px;text-align: right;min-width:130px;max-width:130px;justify-content:flex-end;">
                <span translate>Deposits</span>
                <filter class="mat-filter" [data]="angularMatData" columnName="Deposits" dataType="string"></filter>
            </th>
            <td mat-cell *matCellDef="let MS"
                style="padding-right:10px;min-width:130px;max-width:130px;justify-content:flex-end;text-align: right;padding-right: 75px;"
                [ngStyle]="{'color':MS.Deposits == 0 ? '#939393' : 'black'}">{{MS.Deposits}}</td>
        </ng-container>
        <ng-container matColumnDef="Net">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
                style="padding-right:10px;min-width:80px;max-width:80px;justify-content:flex-end;text-align: right;"
                translate>Net
                <filter class="mat-filter" [data]="angularMatData" columnName="Net" dataType="string"></filter>
            </th>
            <td mat-cell *matCellDef="let MS"
                style="padding-right:10px;min-width:80px;max-width:80px;justify-content:flex-end;text-align: right;padding-right: 55px;"
                [ngStyle]="{'color':MS.Net == 0 ? '#939393' : 'black'}">{{MS.Net}}</td>
        </ng-container>
        <ng-container matColumnDef="NetCharge">
            <th mat-header-cell *matHeaderCellDef style="min-width:80px;max-width:80px;"></th>
            <td mat-cell *matCellDef="let MS"
                style="min-width:80px;max-width:80px;text-align: right;padding-right: 55px;">{{MS.Net > 0 ? 'Deposit' :
                (MS.Net < 0 ? 'Charge' : '' ) | translate}}</td>
        </ng-container>
        <ng-container matColumnDef="Balance">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
                style="padding-left:10px;min-width:80px;max-width:80px;text-align: right;">
                <span translate>Balance</span>
                <filter class="mat-filter" [data]="angularMatData" columnName="Balance" dataType="string"></filter>
            </th>
            <td mat-cell [ngStyle]="{'background-color':MS.Balance < 0 ? '#ffff99' : ''}" *matCellDef="let MS"
                style="min-width:80px;max-width:80px;padding-right:20px;justify-content:flex-end;text-align: right;padding-right: 25px;">
                <span [ngStyle]="{'color':MS.Balance == 0 ? '#939393' : 'black'}" style="justify-content:flex-end;">
                    {{ (MS.Balance > 0 ? MS.Balance : MS.Balance*-1) | number:'1.2-2'}}
                </span>
            </td>
        </ng-container>
        <ng-container matColumnDef="Overdrawn">
            <th mat-header-cell *matHeaderCellDef style="min-width:90px;max-width:90px;">
            </th>
            <td mat-cell [ngStyle]="{'background-color':MS.Balance < 0 ? '#ffff99' : ''}" *matCellDef="let MS"
                style="min-width:90px;max-width:90px;text-align: right;padding-right: 55px;">
                <span [ngStyle]="{'color':MS.Balance == 0 ? '#939393' : 'black'}">
                </span>
                <span [ngStyle]="{'background-color':MS.Balance < 0 ? '#ffff99' : ''}" *ngIf="MS.Balance < 0" translate>
                    Overdrawn</span>
            </td>
        </ng-container>
        <ng-container matColumnDef="expandedDetail">
            <td mat-cell *matCellDef="let AH" [attr.colspan]="columnsToDisplay.length"
                style="width:100%; overflow: hidden;" class="mat-detail-card">
                <div class="mat-detail-card" style="margin-left: 70px;" *ngIf="angularMatData.checkVisible(AH)">
                    <mat-table [dataSource]="AH.MealServiceDetailItems" style="width: 100%;" id="MDdataTable"
                        tabindex="-1">
                        <ng-container matColumnDef="MealGroup">
                            <mat-header-cell *matHeaderCellDef style="min-width:150px;"><span translate>Meal
                                    Group</span>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let detail" style="min-width:150px;">{{detail.MealGroup}}</mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="ItemType">
                            <mat-header-cell *matHeaderCellDef style="min-width:150px;"><span translate>Item Type</span>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let detail" style="min-width:150px;">{{detail.ItemType}}</mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="Item">
                            <mat-header-cell *matHeaderCellDef style="min-width:150px;"><span translate>Item</span>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let detail" style="min-width:150px;">
                                <a *ngIf="detail.MealGroup == 'Lunch' && detail.ItemType == 'Meal'"
                                    [ngClass]="{'btn btn-link':detail.Item == 'Staff/Student Lunch'}"
                                    (click)="getLunchMealChoices(AH.Date)">{{detail.Item}}</a>

                                <span style="color: black;text-decoration-line: none"
                                    *ngIf="detail.MealGroup != 'Lunch' || detail.ItemType != 'Meal'">{{detail.Item}}</span>
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="TransactionType">
                            <mat-header-cell *matHeaderCellDef style="min-width:150px;"><span
                                    translate>Transaction</span>
                                Type</mat-header-cell>
                            <mat-cell *matCellDef="let detail" style="min-width:150px;">{{detail.TransactionType}}
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="Charge">
                            <mat-header-cell *matHeaderCellDef style="min-width:150px;"><span translate>Charge</span>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let detail" style="min-width:150px;">
                                <span *ngIf="detail.TransactionType == 'Refund' && detail.Charge != 0"
                                    [ngStyle]="{'color' : detail.TransactionType == 'Charge' && detail.Charge == 0 ? 'black' : detail.Charge == 0 ? '#939393' : 'black'}">-</span>
                                <span
                                    [ngStyle]="{'color' : detail.TransactionType == 'Charge' && detail.Charge == 0 ? 'black' : detail.Charge == 0 ? '#939393' : 'black'}">
                                    {{detail.Charge}}
                                </span>
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="Deposit">
                            <mat-header-cell *matHeaderCellDef style="min-width:150px;"><span translate>Deposit</span>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let detail" style="min-width:150px;">
                                <span *ngIf="detail.TransactionType == 'Refund' && detail.Deposit != 0"
                                    [ngStyle]="{'color' : detail.Deposit == 0 ? '#939393' : 'black'}">-</span>
                                <span [ngStyle]="{'color' : detail.Deposit == 0 ? '#939393' : 'black'}">
                                    {{detail.Deposit}}&nbsp;&nbsp;
                                </span>
                            </mat-cell>
                        </ng-container>
                        <ng-container matColumnDef="Processed">
                            <mat-header-cell *matHeaderCellDef style="min-width:150px;"><span translate>Processed</span>
                            </mat-header-cell>
                            <mat-cell *matCellDef="let detail" style="min-width:150px;">
                                {{detail.Processed|date:'MM/dd/yy h:mm a'}}
                            </mat-cell>
                        </ng-container>
                        <mat-header-row *matHeaderRowDef="columnsToDisplayDetailRow" tabindex="-1" id="MDdataHeader">
                        </mat-header-row>
                        <mat-row *matRowDef="let row; columns: columnsToDisplayDetailRow" tabindex="0"></mat-row>
                    </mat-table>
                </div>
            </td>
        </ng-container>

        <!-- Parent Header Row -->
        <ng-container matColumnDef="More1">
            <th mat-header-cell *matHeaderCellDef [attr.rowspan]="2" style="min-width:100px;max-width:100px;" translate>
                More</th>
        </ng-container>
        <ng-container matColumnDef="Date1">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.rowspan]="2"
                style="min-width:120px;max-width:120px;">
                <span translate>Date</span>
                <filter class="mat-filter" [data]="angularMatData" columnName="Date" dataType="date"></filter>
            </th>
        </ng-container>
        <ng-container matColumnDef="header-row-breakfast">
            <th mat-header-cell *matHeaderCellDef [attr.colspan]="2"
                style="text-align: center; border: thin solid lightgray; border-bottom: none; padding-top: 0px !important;"
                translate> Breakfast </th>
        </ng-container>
        <ng-container matColumnDef="header-row-lunch">
            <th mat-header-cell *matHeaderCellDef [attr.colspan]="2"
                style="text-align: center; border: thin solid lightgray; border-bottom: none; padding-top: 0px !important;"
                translate> Lunch </th>
        </ng-container>
        <ng-container matColumnDef="header-row-snack">
            <th mat-header-cell *matHeaderCellDef [attr.colspan]="2"
                style="text-align: center; border: thin solid lightgray; border-bottom: none; padding-top: 0px !important;"
                translate> Snack </th>
        </ng-container>
        <ng-container matColumnDef="header-row-other">
            <th mat-header-cell *matHeaderCellDef [attr.colspan]="2"
                style="text-align: center; border: thin solid lightgray; border-bottom: none; padding-top: 0px !important;"
                translate> Other </th>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columnSpanToDisplay">
        </tr>
        <!-- Parent Header Row End -->

        <tr mat-header-row *matHeaderRowDef="columnsToDisplay" style="position: sticky;top: 0;background: white;">
        </tr>
        <tr mat-row *matRowDef="let row; columns: columnsToDisplay; let i = index;" id="MSdataRow{{i}}" matRipple
            (click)="toggleExpanded(row)" (keydown)="rowKeyPress($event, row)"
            [ngStyle]="{'border-bottom-width':checkExpanded(row) ? '0px' : '1px'}"
            [attr.aria-label]="getMealServiceAriaRow(row)" tabindex="0" style="padding:0px;"></tr>
            
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']"
            [@detailExpand]="checkExpanded(row) && row.MealServiceDetailItems.length > 0 ? 'expanded' : 'collapsed'"
            (@detailExpand.start)="$event.toState == 'expanded' ? angularMatData.setVisible(row, true) : null"
            (@detailExpand.done)="$event.toState == 'collapsed' ? angularMatData.setVisible(row, false) : null"
            style="overflow: hidden ;" [ngStyle]="{'display': checkExpanded(row) ? '':'none'}" class="mat-detail-row">
        </tr>
    </table>
</div>